// extracted by mini-css-extract-plugin
export default {"box":"inventorySparesListingPage_box__c9CWb"};